import { createAsyncActionConstants } from 'utilities/util';

export const TYPES = {
    FETCH_PARTNERS: createAsyncActionConstants('FETCH_PARTNERS'),
    RESET_PARTNERS: createAsyncActionConstants('RESET_PARTNERS')
}